module.exports = __webpack_public_path__ + "img/28.a872a4d6.webp";